import React from "react";
import { Icon } from "./icons";

const OFFERS = [
  {
    icon: "route",
    title: "Trajet à la distance",
    price: "1,90 €",
    unit: "/ km",
    lines: ["Devis immédiat en ligne", "Aller simple ou aller-retour", "France & Europe"],
  },
  {
    icon: "backpack",
    title: "Ramassage scolaire",
    price: "Sur devis",
    unit: "",
    lines: ["Forfait à la semaine ou au mois", "Domicile ↔ école", "Trajets réguliers"],
    featured: true,
  },
  {
    icon: "calendar",
    title: "Mise à disposition",
    price: "Sur devis",
    unit: "",
    lines: ["Demi-journée, journée", "Soirée, week-end", "Chauffeure dédiée"],
  },
];

export const Tarifs = () => (
  <section id="tarifs" className="section tarifs">
    <div className="container">
      <h2 className="section-title">Nos tarifs</h2>
      <p className="section-lead">
        Des prix clairs, annoncés avant le départ. Aucun supplément surprise.
      </p>

      <div className="tarifs-grid">
        {OFFERS.map((o) => (
          <article className={`tarif-card ${o.featured ? "is-featured" : ""}`} key={o.title}>
            <span className="tarif-icon">
              <Icon name={o.icon} size={28} />
            </span>
            <h3>{o.title}</h3>
            <p className="tarif-price">
              {o.price}
              <em>{o.unit}</em>
            </p>
            <ul>
              {o.lines.map((l) => (
                <li key={l}>{l}</li>
              ))}
            </ul>
            <a href="#reservation" className="btn btn-outline btn-block">
              Obtenir un devis
            </a>
          </article>
        ))}
      </div>
    </div>
  </section>
);

export default Tarifs;
